<template>
  <div>
    <input
      :class="{
        is_searching: is_searching,
        search_field_z_index: is_searching
      }"
      class="full search_field"
      @focus="is_searching=true"
      @blur="is_searching=false"
      @input="search"
      type="text"
      placeholder="Search"
    />
  </div>
</template>
<script>
import { mapMutations, mapGetters } from 'vuex'
export default {
  name: 'search-box',
  data () {
    return {
      is_searching: false
    }
  },
  computed: {
    ...mapGetters('modals', ['isModalOpen', 'findModal'])
  },
  methods: {
    search (event) {
      let modal = this.findModal({ type: 'designator', value: 'search-modal' })
      let keyword = event.target.value.trim()
      if (keyword.length == 0) {
        this.is_searching = false
        this.remove(modal)
        return
      }
      if (this.isModalOpen({ type: 'designator', value: 'search-modal' })) {
        modal.keyword = keyword
        this.update(modal)
        return
      }
      this.create({ designator: 'search-modal', component_name: 'SearchModalDisplay', keyword: keyword, modal_title: 'Search' })
    },
    ...mapMutations('modals', ['create', 'update', 'remove'])
  }
}
</script>
<style scoped>
  .search_field {
    position: relative;
    transition: all 0.2s;
  }
  .search_field_z_index {
    z-index: 10000000;
  }
  .is_searching {
    background-color: white !important;
    color: var(--color-text) !important;
  }
</style>
